var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',[_c('b-form-input',{attrs:{"id":_vm.id,"type":"number","value":_vm.input_value},on:{"input":_vm.handleInput}}),_c('b-input-group-append',[_c('b-input-group-text',[_vm._v("%")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }